import { z } from 'zod';

/////////////////////////////////////////
// CASE CLASSIFICATION SCHEMA
/////////////////////////////////////////

export const CaseClassificationSchema = z.object({
  classificationId: z.number().int(),
  cityId: z.number().int(),
  departmentId: z.number().int(),
  classificationText: z.string(),
  assignToId: z.number().int(),
  expectCloseDays: z.string(),
  visibility: z.number().int(),
  displayGroup: z.string(),
  templateCode: z.string(),
  displayGroupId: z.number().int(),
  displayOrder: z.number().int(),
  faqText: z.string(),
  empFaqText: z.string(),
  faqKeywords: z.string(),
  faqStartDate: z.coerce.date(),
  faqEndDate: z.coerce.date(),
  faqRank: z.number().int(),
  faqForce: z.number().int(),
  faqForceStartDate: z.coerce.date(),
  faqForceEndDate: z.coerce.date(),
  faqFlag: z.string(),
  emailGroup: z.string(),
  notifyId: z.number().int(),
  active: z.number().int(),
  fieldAttributes: z.string(),
  twid: z.number().int(),
  twLastUpdate: z.string(),
  cpConfig: z.string(),
  classificationDescription: z.string(),
  lastUpdated: z.coerce.date().nullable(),
})

export type CaseClassification = z.infer<typeof CaseClassificationSchema>

export default CaseClassificationSchema;
